<script>
  import '@nrk/nrkno-player/index.css'
  import { onMount } from 'svelte'
  export let data

  const { id, aspect } = data
  const videoId = id.split('/').pop()
  const aspectRatio = aspect?.replace(/:/, 'x') || '16x9'

  onMount(async () => {
    if (customElements.get('nrkno-player') === undefined) {
      const { NrknoPlayerElement } = await import('@nrk/nrkno-player').then((m) => m.default || m)

      requestAnimationFrame(() => {
        if (customElements.get('nrkno-player') === undefined) {
          customElements.define('nrkno-player', NrknoPlayerElement)
        }
      })
    }
  })
</script>

<nrkno-player
  class={`-player aspect-ratio aspect-ratio--${aspectRatio}`}
  type="player"
  src={videoId}
>
  <video />
</nrkno-player>

<style>
  .-player {
    width: 100%;
  }
</style>
